"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickListenerService = void 0;
const listenerToken_1 = require("../support/listenerToken");
class ClickListenerService {
    constructor() {
        this.registry = new Map();
        this.tokenToChunk = new Map();
    }
    async registerListener(chunk, callback) {
        const registrationToken = await listenerToken_1.generateListenerToken();
        this.tokenToChunk.set(registrationToken, chunk);
        const chunkKey = chunk.asMapKey();
        if (this.registry.has(chunkKey)) {
            this.registry.get(chunkKey).set(registrationToken, callback);
        }
        else {
            const innerMap = new Map();
            innerMap.set(registrationToken, callback);
            this.registry.set(chunkKey, innerMap);
        }
        return registrationToken;
    }
    unregisterListener(token) {
        if (this.tokenToChunk.has(token)) {
            return;
        }
        const chunkKey = this.tokenToChunk.get(token).asMapKey();
        if (this.registry.has(chunkKey)) {
            this.registry.get(chunkKey).delete(token);
        }
        this.tokenToChunk.delete(token);
    }
    onClick(clickUpdate) {
        if (!this.registry.has(clickUpdate.position.getChunk().asMapKey())) {
            return;
        }
        this.registry.get(clickUpdate.position.getChunk().asMapKey())
            .forEach(cb => setTimeout(() => cb(clickUpdate), 0));
    }
}
exports.ClickListenerService = ClickListenerService;
//# sourceMappingURL=ClickListenerService.js.map